module.exports = __webpack_public_path__ + "static/media/Imagenes-Blog1-1200x439.5ddf53fa.png";